import { useTheme } from '@mui/system';

export const SavedBookmarkSVG = ({
  stroke = 'transparent',
}: {
  stroke?: string;
}) => {
  const theme = useTheme();

  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 11.5V13.0165L2.89392 12.4191L6 11.088L9.10608 12.4191L10.5 13.0165V11.5V3.5C10.5 2.39772 9.60228 1.5 8.5 1.5H3.5C2.39772 1.5 1.5 2.39772 1.5 3.5V11.5Z"
        fill={theme.palette.warning.main}
        stroke={stroke}
        strokeWidth="2"
      />
    </svg>
  );
};
